import ActionTypes from '../constants';

const initialState = {
    vendors: {},
    vendor: {}
    // loading: false,
};

const vendorReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.LOADING:
            return {
                ...state,
                loading: true
            }
        case ActionTypes.GETVENDORSUCCESS:
            return {
                ...state,
                vendors: action.payload,
            }
        case ActionTypes.GETVENDORBYIDSUCCESS:
            return {
                ...state,
                vendor: action.payload,
            }
        default:
            return state;
    }
}

export default vendorReducer;